var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "copy-wrapper", on: { click: _vm.copyToClipboard } },
    [
      _vm._t("default"),
      _vm.withIcon && _vm.copy
        ? _c("q-icon", {
            attrs: { name: "content_copy", color: "primary", size: "16px" }
          })
        : _vm._e(),
      _c("input", {
        staticClass: "clipboard-copy-input",
        attrs: { id: "copy-" + _vm.id },
        domProps: { value: _vm.copy }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }